/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Segment } from '../../models/segment';
import { SegmentResponse } from '../../models/segment-response';

export interface UpdateSegment$Params {
  'Active-Tenant-Identifier': string;
  segmentId: string;
      body: SegmentResponse
}

export function updateSegment(http: HttpClient, rootUrl: string, params: UpdateSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<Segment>> {
  const rb = new RequestBuilder(rootUrl, updateSegment.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('segmentId', params.segmentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Segment>;
    })
  );
}

updateSegment.PATH = '/segments/{segmentId}';
